import React from 'react';
import PropTypes from 'prop-types';
import './tooltip.scss';

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  show = () => {
    this.setState({ isShow: true });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  handleMouseEnter = () => {
    if (!this.state.isShow) {
      this.show();
    }
  };

  handleMouseLeave = () => {
    if (this.state.isShow) {
      this.hide();
    }
  };

  getClassName = () => {
    const { appendClassName } = this.props;

    return Array.isArray(appendClassName)
      ? appendClassName.join(' ')
      : appendClassName;
  };

  render() {
    const { isShow } = this.state;
    const {
      render,
      position,
      enabled,
      isLight,
      appendStyle,
      alwaysShow,
    } = this.props;

    return (
      <span
        style={appendStyle}
        className={`${
          isLight ? 'tooltip-light-wrap' : 'tooltip-wrap'
        } ${this.getClassName()}`}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {(alwaysShow || (enabled && isShow)) && (
          <div className={`tooltip-content tooltip-${position}`}>
            {render({ className: 'tooltip-message ' })}
          </div>
        )}
        {this.props.children}
      </span>
    );
  }
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  render: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  isLight: PropTypes.bool,
  appendClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  appendStyle: PropTypes.object,
};

Tooltip.defaultProps = {
  isLight: false,
};

export default Tooltip;
